import { CacheService, CacheStorageModeEnum } from './cache.service';

export interface CacheOptions {
  maxAge?: number;
  storageMode?: string;
}

export class CacheFactory {

  private setOptions: any = {};

  public static createCache(name: string, options?: CacheOptions): CacheFactory {
    const cacheService = new CacheService();
    return new CacheFactory(name, options, cacheService);
  }

  /*
  * constructor is for internal use. please use static createCache() function externally.
  */
  constructor(
    public name: string,
    private options: any,
    private cacheService: CacheService
  ) {
    this.options = this.options || {};

    if (this.options.storageMode && this.options.storageMode === 'sessionStorage') {
      this.cacheService = this.cacheService.useStorage(CacheStorageModeEnum.SESSION);
    } else if (this.options.storageMode && this.options.storageMode === 'localStorage') {
      this.cacheService = this.cacheService.useStorage(CacheStorageModeEnum.LOCAL);
    } else {
      this.cacheService = this.cacheService.useStorage(CacheStorageModeEnum.MEMORY);
    }

    if (this.options.maxAge) {
      this.setOptions.maxAge = this.options.maxAge;
    }

    this.cacheService.setGlobalPrefix(name);
  }

  public set(key: string, data: any, tag?: string): boolean {
    return this.cacheService.set(key, data, { tag });
  }

  public put(key: string, data: any, tag?: string): boolean {
    let options = _.clone(this.setOptions);
    if (tag) {
      options.tag = tag;
    }
    return this.cacheService.set(key, data, options);
  }

  public get(key: any): any {
    return this.cacheService.get(key);
  }

  public remove(key: any): void {
    this.cacheService.remove(key);
  }

}
